// extracted by mini-css-extract-plugin
export default {"modal":"MessageTemplateManagementModal-module__modal__Fbdmv","content":"MessageTemplateManagementModal-module__content__dPPMB"};